import { Button, Form, Input, Typography } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import AppSelectFilter from "../components/Items/AppSelectFilter";
import AppModalWrapper from "../components/Items/Modal/AppModalWrapper";
import useMultiNotification from "../hooks/useNotification";
import { reloadProfileApi } from "../redux-toolkit/slices/dashboardSlice";
import {
  assignFormulaToOrderApi,
  reloadOrdersApi,
} from "../redux-toolkit/slices/ordersSlice";
import { RootState, useAppDispatch } from "../redux-toolkit/store/store";

const AssignFormulaToOrderModal: React.FC<AssignFormulaToOrderModalProps> = ({
  show,
  handleClose,
  orderId,
  painLocations,
}) => {
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const { miniFormulas } = useSelector((state: RootState) => state.formulas);
  const { ordersData } = useSelector((state: RootState) => state.orders);
  const [formulaOptions] = useState(
    miniFormulas.map((item) => {
      return {
        value: item._id,
        label: `${item.activeIngredients}(${item.creamBase})`,
      };
    })
  );
  const onFinish = async (values: any) => {
    try {
      const dataToSend: IAssignFormulaToOrderApiProp = {
        formulaId: values.formulaId,
        orderId: orderId,
        instructions: `Apply ${
          values.frequency || 1
        } times on ${values?.bodyPart?.join(",")} ${values.timeOfDay}`,
        otherInstructions: values.otherInstructions
          ? values.otherInstructions
          : null,
      };

      const res = await dispatch(assignFormulaToOrderApi(dataToSend)).unwrap();
      dispatch(reloadProfileApi(true));
      dispatch(reloadOrdersApi(true));
      openNotification(`success`, `Success`, res.message);
      setTimeout(() => {
        handleClose(true);
      }, 1500);
    } catch (error) {
      if (typeof error === "string") {
        openNotification(`error`, `Error`, error);
      } else {
        openNotification(`error`, `Error`, `Server Error`);
      }
    }
  };
  const onFinishFailed = (data: any) => {};
  return (
    <>
      {contextHolder}
      <AppModalWrapper
        title="Assign Formula"
        headerStyle={{
          backgroundColor: "#f5f5f5",
          color: "#101828",
          fontSize: "16px",
          fontWeight: "700",
          height: "50px",
        }}
        width={"60%"}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        <Form
          name="assignFormulaToOrder"
          initialValues={{
            frequency: 1,
            bodyPart: painLocations,
            timeOfDay: "Others",
          }}
          layout="vertical"
          form={form}
          style={{ padding: "30px" }}
          requiredMark={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={<span>Select Formula</span>}
            name="formulaId"
            rules={[{ required: true, message: "Please Select formula" }]}
          >
            <AppSelectFilter
              options={formulaOptions}
              label=""
              placeHolder="Choose Formula"
              onChange={(e) => {}}
            />
          </Form.Item>
          <div className="instructions-container">
            <Typography className="instructions-container-title">
              Directions for use
            </Typography>
            <div className="apply-items-container">
              <Typography className="apply-items-label">Apply</Typography>
              <Form.Item
                name="frequency"
                rules={[{ required: true, message: "Please Select frequency" }]}
              >
                <AppSelectFilter
                  options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => {
                    return {
                      label: `${item}`,
                      value: `${item}`,
                    };
                  })}
                  label=""
                  placeHolder="Choose Frequency"
                  onChange={(e) => {}}
                />
              </Form.Item>
              <Typography className="apply-items-label">
                Click To affected
              </Typography>
              <Form.Item
                name="bodyPart"
                rules={[{ required: true, message: "Please Select body part" }]}
              >
                <AppSelectFilter
                  mode="multiple"
                  style={{ minWidth: "150px" }}
                  options={[
                    { label: "Head", value: "head" },
                    { label: "Neck", value: "neck" },
                    { label: "Left Shoulder", value: "leftshoulder" },
                    { label: "Chest", value: "chest" },
                    { label: "Right Shoulder", value: "rightshoulder" },
                    { label: "Right Arm", value: "rightarm" },
                    { label: "Left Arm", value: "leftarm" },
                    { label: "Left Hand", value: "lefthand" },
                    { label: "Right Hand", value: "righthand" },
                    { label: "Stomach", value: "stomach" },
                    { label: "Left Hip", value: "lefthip" },
                    { label: "Groin", value: "groin" },
                    { label: "Right Hip", value: "righthip" },
                    { label: "Right Thigh", value: "rightthigh" },
                    { label: "Left Thigh", value: "leftthigh" },
                    { label: "Left Knee", value: "leftknee" },
                    { label: "Left Leg", value: "leftleg" },
                    { label: "Right Knee", value: "rightknee" },
                    { label: "Right Leg", value: "rightleg" },
                    { label: "Right Ankle", value: "rightankle" },
                    { label: "Left Ankle", value: "leftankle" },
                    { label: "Right Foot", value: "rightfoot" },
                    { label: "Left Foot", value: "leftfoot" },
                  ]}
                  label=""
                  placeHolder="Knee(s),leg(s)"
                  onChange={(e) => {}}
                />
              </Form.Item>
              <Form.Item
                name="timeOfDay"
                rules={[{ required: true, message: "Please Select time" }]}
              >
                <AppSelectFilter
                  allowClear={false}
                  style={{ minWidth: "200px" }}
                  options={[
                    `Others`,
                    `Every Day In Morning`,
                    `Every Day In Evening`,
                    `Twice A day`,
                    `Thrice A day`,
                  ].map((item) => {
                    return {
                      label: `${item}`,
                      value: `${item}`,
                    };
                  })}
                  label=""
                  placeHolder="Select"
                  onChange={(e) => {}}
                />
              </Form.Item>
            </div>
            <Form.Item
              label={<span>Other Instructions</span>}
              name="otherInstructions"
            >
              <Input placeholder="Other Instructions" />
            </Form.Item>
          </div>
          <Form.Item style={{ display: "flex", justifyContent: "center" }}>
            <Button type="primary" htmlType="submit">
              Send Order
            </Button>
          </Form.Item>
        </Form>
      </AppModalWrapper>
    </>
  );
};
export default AssignFormulaToOrderModal;
